<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Добавление и&nbsp;редактирование услуги</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте добавим услуги в&nbsp;ваш проект.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Услуги&raquo;. Если вы&nbsp;еще не&nbsp;добавляли
              услуги&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Добавить услугу&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Если вы&nbsp;уже добавляли услуги&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Добавить
            услугу&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="osnovnaya-informacija"
            class="typography__headline2"
          >
            Основная информация
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;основной информации в&nbsp;первую очередь нужно определиться с&nbsp;типом услуги&nbsp;&mdash;
              персональная или групповая. На&nbsp;групповой услуге может быть одновременно несколько как сотрудников,
              так и&nbsp;клиентов.
            </p>

            <p>Название и&nbsp;описание обязательные для заполнения данные.</p>

            <p>Также можно загрузить её&nbsp;фотографию.</p>

            <p>
              Эти элементы будут использоваться в&nbsp;созданном сайте при онлайн-записи или в&nbsp;каталоге услуг,
              поэтому лучше заполнять максимально подробно.
            </p>

            <p>
              Настройкой онлайн-записи управляется доступна услуга к&nbsp;ней или нет. При выключенном состоянии услуга
              будет доступна в&nbsp;каталоге услуг для
              <BaseLink
                target="_blank"
                to="/faq/articles/chto-takoye-zayavki-na-uslugi"
              >оформления заявки</BaseLink>. По-умолчанию активно.
            </p>

            <p>
              Настройкой активности можно быстро полностью скрывать услугу с&nbsp;сайта и&nbsp;отключать
              её&nbsp;от&nbsp;онлайн-записи. По-умолчанию активно.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              При выборе категорий в&nbsp;появившемся окне выберите подходящие под эту услугу и&nbsp;нажмите
              &laquo;Готово&raquo;.
            </p>

            <p>Если вы&nbsp;еще не&nbsp;настраивали категории&nbsp;&mdash;
              <BaseLink
                target="_blank"
                to="/faq/articles/kategorii-uslug"
              >самое время это сделать</BaseLink>.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;стоимости услуги можно выставить скидку. Для этого нажмите на&nbsp;переключатель
            &laquo;Распродажа&raquo; и&nbsp;заполните цену со&nbsp;скидкой.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="sotrudniki"
            class="typography__headline2"
          >
            Сотрудники
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Сотрудники выбираются для онлайн-записи или просмотра этой информации (что этот сотрудник выполняет эту
              услугу) на&nbsp;сайте, нажав &laquo;Выбрать сотрудников&raquo;.
            </p>

            <p>
              Если вам это не&nbsp;нужно и&nbsp;настройка онлайн-записи отключена в&nbsp;блоке с&nbsp;основной
              информацией&nbsp;&mdash; можете не&nbsp;заполнять этот блок.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;появившемся окне выберите сотрудников, оказываемых добавляемую услугу и&nbsp;нажмите
              &laquo;Готово&raquo;.
            </p>

            <p>В&nbsp;окне также можно быстро добавить нового, не&nbsp;забудьте после
              <BaseLink
                target="_blank"
                to="/faq/articles/dobavleniye-i-redaktirovaniye-sotrudnika"
              >заполнить все его данные</BaseLink>.
            </p>

            <p>После выбора нужных сотрудников нажмите &laquo;Готово&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После выбора сотрудников, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
            из&nbsp;списка ненужные.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="adresy-predostavleniya"
            class="typography__headline2"
          >
            Адреса предоставления
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Адреса выбираются для онлайн-записи на&nbsp;сайте, нажав &laquo;Выбрать адреса&raquo;.</p>

            <p>
              Если вам это не&nbsp;нужно и&nbsp;настройка онлайн-записи отключена в&nbsp;блоке с&nbsp;основной
              информацией&nbsp;&mdash; можете не&nbsp;заполнять этот блок.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;окне выбора адреса также можно быстро добавить новый, не&nbsp;забудьте после
              <BaseLink
                target="_blank"
                to="/faq/articles/kontakty-i-dannye-filialov"
              >заполнить все его данные</BaseLink>.
            </p>

            <p>После выбора нужных филиалов нажмите &laquo;Готово&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После выбора адресов, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
            из&nbsp;списка ненужные.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="galereya-i-dobavlenie-uslugi"
            class="typography__headline2"
          >
            Галерея и добавление услуги
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;галерею услуги можно загрузить до&nbsp;10&nbsp;изображений в&nbsp;разрешении Jpeg, Jpg или Png,
              с&nbsp;максимальным весом 5&nbsp;Мб. Загружать можно разом несколько картинок.
            </p>

            <p>Эти элементы будут использоваться в&nbsp;созданном сайте, поэтому важно их&nbsp;заполнить.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-14.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как заполните всю нужную информацию об&nbsp;услуге, нажмите &laquo;Добавить&raquo; в&nbsp;самом низу
            страницы. После успешного добавления увидите в&nbsp;правом верхнем углу уведомление.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-15.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="redaktirovanie-uslugi"
            class="typography__headline2"
          >
            Редактирование услуги
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              После добавления услуги, вы&nbsp;сможете найти её&nbsp;в&nbsp;<BaseLink
              target="_blank"
              to="/faq/articles/spisok-uslug-i-ikh-dannye"
            >списке услуг</BaseLink>.
            </p>

            <p>Отсюда можно быстро перейти к&nbsp;редактированию по&nbsp;иконке карандаша справа.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-uslugi-16.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С&nbsp;добавлением услуги разобрались. Самое время перейти к&nbsp;изучению
            <BaseLink target="_blank" to="/faq/articles/spisok-uslug-i-ikh-dannye">
              списка услуг и&nbsp;просмотра их&nbsp;данных</BaseLink>.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Онлайн-&#65279;запись",
    url: "/faq/categories/onlayn-zapis",
  },
  {
    name: "Добавление и&nbsp;редактирование услуги",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Основная&nbsp;информация",
    url: "osnovnaya-informacija",
  },
  {
    name: "Сотрудники",
    url: "sotrudniki",
  },
  {
    name: "Адреса&nbsp;предоставления",
    url: "adresy-predostavleniya",
  },
  {
    name: "Галерея&nbsp;и&nbsp;добавление&nbsp;услуги",
    url: "galereya-i-dobavlenie-uslugi",
  },
  {
    name: "Редактирование&nbsp;услуги",
    url: "redaktirovanie-uslugi",
  },
];

const relatedArticles = [
  {
    name: "Настройки записей",
    slug: "nastroyki-zapisey",
  },
  {
    name: "Категории услуг",
    slug: "kategorii-uslug",
  },
  {
    name: "Список услуг и&nbsp;их данные",
    slug: "spisok-uslug-i-ikh-dannye",
  },
  {
    name: "Добавление и&nbsp;редактирование записи",
    slug: "dobavlenie-i-redaktirovanie-zapisi",
  },
];

useSeoMeta({
  title: "Добавление и редактирование услуги",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

p a {
  display: contents;
}
</style>
